import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'
import { connect } from 'react-redux'

import { formatImageUrl } from 'embed/utils'
import { isDev } from 'embed/constants/config'
import { CreditOffer } from 'embed/constants/models'
import { Product } from 'even-ts-static'

import AdvertiserDisclosure from 'embed/components/AdvertiserDisclosure'
import { MultiProductState } from 'embed/reducers'
import { CreditModal } from '../../CreditModal'
import { useTheme } from 'embed/hooks'

const styles = require('embed/styles/application')

interface Props {
  children?: React.ReactNode
  selectedOffer: CreditOffer
}

const SelectedCardView: React.FC<Props> = ({ children, selectedOffer }) => {
  const [disclaimerModalVisible, setDisclaimerModalVisible] = React.useState(false)
  const { colorPrimary, colorTextPrimary, fontFamilyPrimary } = useTheme()

  const toggleDisclaimerModal = React.useCallback(() => {
    setDisclaimerModalVisible(!disclaimerModalVisible)
  }, [disclaimerModalVisible])

  return (
    <React.Fragment>
      {selectedOffer && (
        <section
          className={styles.offerSection}
          data-test-id="selected_creditcard_offer"
          data-test-val={isDev ? selectedOffer.uuid : ''}
        >
          <h2
            className={classnames(
              styles.heading,
              css`
                font-family: ${fontFamilyPrimary};
              `,
            )}
          >
            Selected Offer
          </h2>
          <div className={styles.advertiserDisclosure}>
            <AdvertiserDisclosure />
          </div>
          <div className={styles.selectedCard}>
            <img
              alt={selectedOffer.details.cardName}
              className={styles.cardImage}
              src={formatImageUrl(selectedOffer.details.cardImageUrl)}
            />
            <div className={styles.cardDetails}>
              <div className={styles.cardName}>{selectedOffer.details.cardName}</div>
              <p
                className={classnames(
                  styles.disclaimerLink,
                  css`
                    color: ${colorPrimary};
                    &:hover {
                      color: ${colorTextPrimary};
                    }
                  `,
                )}
                onClick={toggleDisclaimerModal}
              >
                See all details
              </p>
              {!!disclaimerModalVisible && <CreditModal offer={selectedOffer} onDismiss={toggleDisclaimerModal} />}
            </div>
          </div>
          {children}
        </section>
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (state: MultiProductState) => ({
  selectedOffer: state.rates.selected[Product.CreditCard],
})

export const SelectedCard = connect(mapStateToProps)(SelectedCardView)
